import type { ComponentConfig } from '@puckeditor/core';
import { ProcessSteps } from './process-steps';
import { ProcessStepsFields } from "./process-steps.fields";
import type { ProcessStepsProps } from './process-steps';
import { RegenerableTextField } from "../editor/RegenerableTextField";

const ProcessStepsConfig: ComponentConfig<ProcessStepsProps> = {
  defaultProps: {
    heading: "How Our Process Works",
    layout: "vertical",
    steps: [
      {
        description:
          "Give us a call or fill out our online form to request service. We'll respond quickly to discuss your needs.",
        step: 1,
        title: "Contact Us",
      },
      {
        description:
          "We'll provide a detailed, upfront estimate so you know exactly what to expect. No hidden fees or surprises.",
        step: 2,
        title: "Free Estimate",
      },
      {
        description:
          "Choose a time that works for your schedule and our licensed professionals will complete the work to the highest standards.",
        step: 3,
        title: "Schedule Service",
      },
    ],
    subheading: "We make it simple to get the service you need with our straightforward process.",
    tone: "light",
    variant: "standard",
  },
  fields: {
    heading: {
      ...ProcessStepsFields.heading,
      contentEditable: true,
      render: ({ value, onChange, field }) => (
        <RegenerableTextField
          value={value || ""}
          onChange={onChange}
          namespace="processSteps.heading"
          label="Heading"
          multiline={false}
          fieldMeta={field?.metadata}
        />
      ),
    },
    subheading: {
      ...ProcessStepsFields.subheading,
      contentEditable: true,
      render: ({ value, onChange, field }) => (
        <RegenerableTextField
          value={value || ""}
          onChange={onChange}
          namespace="processSteps.subheading"
          label="Subheading"
          multiline={true}
          fieldMeta={field?.metadata}
        />
      ),
    },
    layout: ProcessStepsFields.layout,
    variant: ProcessStepsFields.variant,
    tone: ProcessStepsFields.tone,
    steps: ProcessStepsFields.steps as any,
    accentColor: ProcessStepsFields.accentColor,
    backgroundColor: ProcessStepsFields.backgroundColor,
  },
  // Display label names the structure, not one use: numbered steps serve a
  // Process, a timeline, or a how-it-works equally. The registry key stays
  // ProcessSteps — it's persisted in every page's Puck data.
  label: "Steps",
  render: ({ id, puck: _puck, editMode: _editMode, ...props }) => <ProcessSteps id={id} {...props} />,
};

export { ProcessStepsConfig };
